import { getUserDetail, registUserInfo } from "@/server/interfaces"
import resolveDefaultOpt from "@/utils/resolveDefaultOpt"
import { env } from "@/config"

const DEFAULT_USER_HEADER = "https://static.nfapp.southcn.com/uc/AvatarImg/default.png"

export default {
  namespaced: true,
  state: {
    userInfo: {
      userUuid: "",
      // userUuid: "ec514514-4d2c-4449-9130-0ec3e5806fb6",
      phone: "",
      userName: "",
      headImg: DEFAULT_USER_HEADER,
      area: {},
      school: {
        schoolId: "",
        schoolName: "",
        optionSchoolType: "USER_FILL"
      },
      grade: {},
      company: {},
      advisor: "",
      advisorPhone: "",
      worksNum: "",
      likeNum: "",
      userId: "",
      ...resolveDefaultOpt()
    },
    hasPerfectedUserInfo: false,
    selectSchoolInfo: {},
    selectUnitInfo: {},
    nextRouteName: "",
    unShowHead: false
  },
  getters: {
    userInfo: state => state.userInfo,
    hasPerfectedUserInfo: state => state.hasPerfectedUserInfo,
    userUuid: state => state.userInfo.userUuid,
    selectSchoolInfo: state => state.selectSchoolInfo,
    selectUnitInfo: state => state.selectUnitInfo,
    nextRouteName: state => state.nextRouteName,
    unShowHead: state => state.unShowHead
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = { ...state.userInfo, ...userInfo }
    },
    saveUserDetail(state, userDetail) {
      const resolveUserInfo = resolveDefaultOpt(userDetail.defaultOpt)
      userDetail.userId = userDetail.id
      state.userInfo = { ...state.userInfo, ...userDetail.defaultOpt, ...userDetail, ...resolveUserInfo }
      state.userInfo.headImg = state.userInfo.headImg || DEFAULT_USER_HEADER
    },
    setHasPerfectedUserInfo(state, hasPerfectedUserInfo) {
      state.hasPerfectedUserInfo = hasPerfectedUserInfo
    },
    setSelectSchoolInfo(state, selectSchoolInfo) {
      const resolveSchoolInfo = selectSchoolInfo => {
        selectSchoolInfo.name = selectSchoolInfo.name || selectSchoolInfo.schoolName || ""
        selectSchoolInfo.id = selectSchoolInfo.id || selectSchoolInfo.schoolId || ""
        selectSchoolInfo.optionSchoolType = selectSchoolInfo.id ? "AUTO" : "USER_FILL"
      }
      resolveSchoolInfo(selectSchoolInfo)
      state.selectSchoolInfo = selectSchoolInfo
    },
    setNextRouteName(state, routeName) {
      state.nextRouteName = routeName
    },
    setUnShowHead(state, status) {
      state.unShowHead = status
    },
    setSelectUnitInfo(state, unitItem) {
      state.selectUnitInfo = unitItem
    }
  },
  actions: {
    async getUserInfoBindPhone({ commit, rootState }, options = { bindPhone: true }) {
      const { isNfPlus } = rootState.systemInfo
      if (!isNfPlus) return false
      const stateUserInfo = rootState.userInfo.userInfo
      let hasUserInfo = !!stateUserInfo.userUuid && !!stateUserInfo.phone
      if (hasUserInfo) {
        return hasUserInfo
      }
      let userInfo = await window.nfplusJsbridge.nativeLogin()
      const hasUserUuid = !!userInfo.userUuid
      const hasBindPhone = !!userInfo.phone || !options.bindPhone
      if (options.bindPhone && !hasBindPhone) {
        userInfo = await window.nfplusJsbridge.nativeLogin()
      }
      if (hasUserUuid && hasBindPhone) {
        commit("setUserInfo", userInfo)
        hasUserInfo = true
      } else {
        hasUserInfo = false
      }
      return hasUserInfo
    },
    async getNfplusUserInfo({ rootState, commit }) {
      const { isNfPlus } = rootState.systemInfo
      if (!isNfPlus) return
      const stateUserInfo = rootState.userInfo.userInfo
      let hasUserInfo = !!stateUserInfo.userUuid
      if (hasUserInfo) {
        return hasUserInfo
      }
      let userInfo = await window.nfplusJsbridge.getUserInfo()
      hasUserInfo = !!userInfo.userUuid
      if (hasUserInfo) {
        commit("setUserInfo", userInfo)
      }
      return hasUserInfo
    },
    async getWxUserInfo({ commit, rootState }) {
      const { isWx } = rootState.systemInfo
      if (!isWx) return
      const userInfo = await window.nfWxAuth.getWxUserInfo({
        env,
        needSaveLocalStorage: true
      })
      if (userInfo) {
        commit("setUserInfo", userInfo)
      }
    },
    async getUserInfo({ rootState, dispatch }) {
      const { isWx, isNfPlus } = rootState.systemInfo
      if (isWx) {
        await dispatch("getWxUserInfo")
      }
      if (isNfPlus) {
        await dispatch("getNfplusUserInfo")
      }
    },
    async getUserDetail({ commit, rootState }, params = { params: {} }) {
      const activityId = rootState.activityInfo.activityId
      const userUuid = rootState.userInfo.userInfo.userUuid
      params.params = {
        activityId,
        userUuid,
        ...params.params
      }
      const userInfo = await getUserDetail(params)
      if (userInfo && !userInfo.empty) {
        commit("saveUserDetail", userInfo)
        commit("setHasPerfectedUserInfo", true)
      } else {
        if (userInfo && userInfo.defaultOpt) {
          commit("saveUserDetail", userInfo)
        }
        commit("setHasPerfectedUserInfo", false)
      }
    },
    async saveReviseUserInfo({ commit, rootState }, params) {
      const userUuid = rootState.userInfo.userInfo.userUuid
      const activityId = rootState.activityInfo.activityId
      params.params.userUuid = userUuid
      params.params.activityId = activityId
      const result = await registUserInfo(params)
      if (result) {
        const userFrom = params.params.defaultOpt
        commit("setUserInfo", userFrom)
        return true
      } else {
        return false
      }
    }
  }
}
